import React from "react";

const ExclamationIcon = ({ color }) => {
  return (
    <svg
      width="4"
      height="19"
      viewBox="0 0 4 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.78725 13.0212C0.800086 13.0212 0 12.2213 0 11.234V1.78725C0 0.800256 0.800256 0 1.78725 0C2.77407 0 3.5745 0.800256 3.5745 1.78725V11.234C3.57467 12.2213 2.77441 13.0212 1.78725 13.0212Z"
        fill={color? color: "#C62828"}
      />
      <path
        d="M1.67255 18.0014C2.51862 18.0014 3.20448 17.3155 3.20448 16.4694C3.20448 15.6234 2.51862 14.9375 1.67255 14.9375C0.826493 14.9375 0.140625 15.6234 0.140625 16.4694C0.140625 17.3155 0.826493 18.0014 1.67255 18.0014Z"
        fill={color? color: "#C62828"}
      />
    </svg>
  );
};

export default ExclamationIcon;
